<template>
  <a
    class="relative inline-block"
    :href="to"
    target="_blank"
  >
    <NuxtImg
      :src="`/icons/social/${imageName}.svg`"
      :alt="social"
      width="34"
      height="34"
      :loading="imageLazyLoad ? 'lazy' : 'eager'"
    />
  </a>
</template>

<script setup>
defineOptions({
  name: 'AtomsLinkSocialMedia'
})

const props = defineProps({
  social: {
    type: String,
    default: 'facebook'
  },

  to: {
    type: String,
    required: true
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})

const imageName = computed(() => {
  return getKey(props.social.toLowerCase(), {
    facebook: 'facebook-circle',
    twitter: 'twitter-x',
    linkedin: 'linkedin-circle',
    whatsapp: 'whatsapp',
    emaillight: 'email-v2',
    email: 'email-v3'
  })
})
</script>
